<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 渠道管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="关键字" prop="keywords">
                <el-input v-model="searchform.keywords" placeholder="姓名/手机" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="用户类型" prop="userType" label-width="100px">
                <el-select type="text" filterable v-model="searchform.userType" style="width:100%">
                  <el-option
                    v-for="(item,index) in userType"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>-->
            <el-col :span="6">
              <el-form-item label="注册时间" prop="datelist">
                <el-date-picker
                  style="width:100%"
                  v-model="searchform.datelist"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="search"
                v-permission="['supervise_select']"
              >搜索</el-button>
              <el-button type="primary" @click="add.addshow=!add.addshow">新建</el-button>
            </el-col>
            <el-col :span="8">
              <!-- 导入excel -->
              <el-tooltip class="item" effect="dark" content="仅支持单个文件上传" placement="top-start">
                <el-upload
                  class="upload-demo"
                  :file-list="uploadFiles"
                  ref="upload"
                  :on-success="upLoadSuccess"
                  :on-error="upLoadError"
                  :action="uploadURL"
                  :headers="headers"
                  :auto-upload="false"
                  :limit="1"
                  name="uploadFile"
                >
                  <el-button slot="trigger" type="primary" @click="qingshuju()">选取文件</el-button>
                  <el-button type="success" @click="submitUpload()">导入服务器</el-button>
                  <el-button type="primary">
                    <a href="/tpls/供应商.xlsx" download>下载excel模板</a>
                  </el-button>
                </el-upload>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>{{title}}</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
            <el-table-column prop="name" label="经销商名称" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="phone" label="经销商手机" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="companyName" label="公司名称" width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="新建时间" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="provinceName" label="省" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cityName" label="市" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="areaName" label="区" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="address" label="注册地点" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="state" label="状态" min-width="140" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.state"
                  active-color="#00A854"
                  :active-value="1"
                  inactive-color="#F04134"
                  :inactive-value="0"
                  @change="changeSwitch(scope.row,$event)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="200" show-overflow-tooltip fixed="right">
              <template slot-scope="props">
                <el-button-group>
                  <el-button
                    type="primary"
                    @click="rowupdate(props.row)"
                    icon="el-icon-edit"
                    v-permission="['promotionrule_update']"
                  ></el-button>
                  <el-button
                    type="danger"
                    icon="el-icon-delete"
                    @click="deletedate(props.row.userUuid)"
                    v-permission="['prizemanage_delete']"
                  ></el-button>
                  <el-button type="primary" @click="mankeqrcode(props.row)">生成二维码</el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
          <!-- 二维码弹窗 -->
          <el-dialog title="二维码图片" :visible.sync="codeVisible" width="450px" center>
            <div id="qrcode"></div>
          </el-dialog>
          <!--注册 -->
          <Input-Form :add="add" :search="search" />
          <Update-Form ref="mychild" :update="update" :search="search" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
import store from "@/store";
import {
  vipsearch,
  updatestate,
  makeqrcode,
  deletelist
} from "@/api/market/channel";
import InputForm from "./components/InputForm";
import UpdateForm from "./components/UpdateForm";
export default {
  components: { InputForm, UpdateForm },
  mounted() {
    //请求部门列表数据并且便利到表格
    this.search();
  },
  data() {
    return {
      //基础数据
      title: "经销商列表",
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      codeVisible: false,
      add: {
        addshow: false
      },
      update: {
        form: {
          companyName: null,
          name: null,
          phone: null,
          provinceId: null,
          cityId: null,
          areaId: null,
          address: ""
        },
        row: {},
        show: false
      },
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //导入表格变量
      headers: {
        Token: store.getters.token //从cookie里获取token，并赋值  Authorization ，而不是token
      },
      projectName: "",
      uploadURL: "",
      uploadFiles: [], //上传的文件列表
      userType: [
        {
          value: 1,
          label: "消费者"
        },
        {
          value: 9,
          label: "经销商"
        }
      ],
      searchform: {
        beginTime: null,
        endTime: null,
        keywords: null,
        datelist: [],
        state: 1,
        userType: 9,
        currPage: 1,
        pageSize: 10
      },
      value: true
    };
  },
  methods: {
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      vipsearch(obj).then(response => {
        this.tableData = response.data.rows;
        this.packdate(this.tableData);
        this.total_count = response.data.total;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    // 拼数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {}
    },
    // 修改当行信息
    rowupdate(row) {
      const obj = row;
      this.$refs.mychild.propgetcity(obj.provinceId);
      this.$refs.mychild.propgetdistrict(obj.cityId);
      this.update.form = obj;
      this.update.row = obj;
      this.update.show = true;
    },
    // 状态更新
    changeSwitch(row, state) {
      console.log(row);
      updatestate({
        uuid: row.userUuid,
        state: row.state
      }).then(response => {
        this.search();
      });
    },
    // 转化码为二维码
    qrCode(obj) {
      setTimeout(() => {
        this.$nextTick(function() {
          document.getElementById("qrcode").innerHTML = "";
          let qrcode = new QRCode("qrcode", {
            width: 400,
            height: 400,
            text: obj, // 二维码内容 也可以放url
            colorDark: "#000",
            colorLight: "#fff"
          });
        });
      }, 50);
    },
    mankeqrcode(row) {
      console.log(row);
      this.qrCode("http://h5.mtyt.fun/h5/wechat?q=3," + row.userUuid);
      this.codeVisible = true;
    },
    // 清导入excel
    qingshuju() {
      this.cgong = null;
      this.sbai = null;
      this.tableData = null;
    },
    //文件上传 正常出库导入
    submitUpload() {
      this.uploadURL =
        process.env.VUE_APP_BASE_API +
        "/mtscitech/back/usermanager/import";
      setTimeout(() => {
        this.$refs.upload.submit();
      }, 300);
    },
    //文件上传成功时的钩子
    upLoadSuccess(response, file, fileList) {
      if (response.status_code == 200) {
        this.uploadFiles = [];
        const datatext = JSON.parse(response.data);
        console.log(datatext);
        this.$message({
          message: "上传成功",
          type: "success"
        });
      } else {
        this.$message.error("上传失败，请检查模板是否规范");
      }
    },
    //文件上传失败时的钩子
    upLoadError(response, file, fileList) {
      console.log("项目添加失败");
    },
    //搜索事件
    search() {
      this.currentPage = 1;
      this.Tabledata({
        state: this.searchform.state,
        keywords: this.searchform.keywords,
        userType: this.searchform.userType,
        beginTime:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        endTime:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        page: 1,
        rows: this.searchform.pageSize
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.currPage = currPage;
      this.Tabledata({
        keywords: this.searchform.keywords,
        userType: this.searchform.userType,
        beginTime:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        endTime:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        rows: this.searchform.pageSize,
        page: this.searchform.currPage
      });
      console.log(currPage);
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize;
      this.search();
    },
    //删除按钮事件
    deletedate(obj) {
      this.$confirm("此操作将永久删除该用户信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deletelist({
            uuids: [obj]
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.search();
            } else {
              this.$message({
                type: "woring",
                message: "删除失败!请检查字段"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
</style>